<template>
  <div>
    <PageHeader :schema="$schemas.creditCardAdministrator" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.creditCardAdministrator"
        :service="$api.creditCardAdministrators"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateCreditCardAdministrator',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
